import React, { FC } from 'react'
import SyndicatorReportContainer from 'containers/Syndicators/SyndicatorReport'

const SyndicatorReportPage: FC = () => <SyndicatorReportContainer />

export default SyndicatorReportPage
